import React from 'react';
import classes from './SurveyTipItem.module.scss';
import { SURVEY_TIPS } from '../../pages/pages';
import { SurveyTip } from 'constants/QmeeSurveyTips';
import Card from 'components/atoms/Card/Card';
import A from 'components/atoms/A/A';
import Txt from 'components/atoms/Txt/Txt';
import ChevronIcon from 'components/assets/ChevronIcon';
import Heading from 'components/atoms/Heading/Heading';

export interface Props {
  tip: SurveyTip;
  index: number;
}

const SurveyTipItem: React.FC<Props> = ({ tip, index }) => {
  const { title, icon, path } = tip;

  return (
    <Card component={A} href={`${SURVEY_TIPS.path}/${path}`} className={classes.root}>
      <div className={classes.tipIconContainer}>
        <svg className={classes.tipIcon}>
          <image width="100%" height="100%" href={icon} />
        </svg>
      </div>
      <header className={classes.tipInfo}>
        <Txt component="p" className={classes.tipNumber}>
          Tip {{ index: index + 1 }}
        </Txt>
        <Heading level={2} className={classes.tipName}>
          {title}
        </Heading>
      </header>
      <div className={classes.chevronContainer}>
        <ChevronIcon className={classes.chevronIcon} color="#C3C5D0" />
      </div>
    </Card>
  );
};

export default SurveyTipItem;
